'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createMixins = {};

exports.__exports = createMixins;
